/**
 * Tipos de agendamento que a sincronização automática da Agenda usa.
 *
 * O vínculo entre o evento sincronizado e a classe é feito por comparação exata
 * de `description` (mkg-calendar.component.ts), então renomear ou excluir uma
 * dessas classes desliga a sincronização silenciosamente. Por isso elas são
 * protegidas na tela de tipos de agendamento.
 */
export const BIRTHDAY_CLASS_DESCRIPTION = 'Aniversários';
export const FUTURE_LABOR_CLASS_DESCRIPTION = 'Previsões de Serviço';

export const SYSTEM_CALENDAR_CLASS_DESCRIPTIONS: readonly string[] = [
  BIRTHDAY_CLASS_DESCRIPTION,
  FUTURE_LABOR_CLASS_DESCRIPTION
];

export function isSystemCalendarClass(description?: string): boolean {
  return SYSTEM_CALENDAR_CLASS_DESCRIPTIONS.includes((description ?? '').trim());
}
